// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
}

.app-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px 20px;
  padding: 0.5rem 1rem 0.45rem;
  flex-shrink: 0;
  border-bottom: 1px solid #d8dde3;
  background: #fff;
}

.app-shell-dark .app-header {
  background: #16181c;
  border-bottom-color: #2c3138;
}

.app-header h1 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  flex: 1 1 auto;
  min-width: 12rem;
}

.nsw-region-link {
  display: inline-flex;
  align-items: center;
  padding: 4px 0;
  border-radius: 0;
  background: transparent;
  color: #1f4e79;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 600;
  flex-shrink: 0;
  letter-spacing: 0.01em;
}

.nsw-region-link:hover {
  background: transparent;
  color: #163a5a;
  text-decoration: underline;
}

.app-shell-dark .nsw-region-link {
  background: transparent;
  color: #8ec5e8;
}

.app-shell-dark .nsw-region-link:hover {
  background: transparent;
  color: #c5e1f5;
}

.map-search-bar {
  flex: 1 1 280px;
  max-width: 520px;
  margin: 0;
}

.map-search-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 4px;
}

.map-search-controls {
  display: flex;
  gap: 6px;
  align-items: stretch;
}

.map-search-input {
  flex: 1 1;
  min-width: 0;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid #c5ccd4;
  padding: 6px 9px;
  font-size: 0.85rem;
}

.map-search-btn {
  border: 1px solid #c5ccd4;
  border-radius: 2px;
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  background: #fff;
  color: #1e293b;
  flex-shrink: 0;
}

.map-search-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.map-search-btn-primary {
  background: #2980b9;
  color: #fff;
}

.map-search-btn-icon {
  padding: 7px 10px;
  font-size: 1rem;
  line-height: 1;
}

.map-search-error {
  color: #dc2626;
  font-size: 0.8rem;
  margin-top: 4px;
}

.app-shell-dark .map-search-label {
  color: #94a3b8;
}

.app-shell-dark .map-search-input {
  background: #1a1d23;
  border-color: #475569;
  color: #f1f5f9;
}

.app-shell-dark .map-search-btn {
  background: #3a3f4b;
  color: #f1f5f9;
}

.app-shell-dark .map-search-btn-primary {
  background: #2980b9;
  color: #fff;
}

.workspace {
  flex: 1 1;
  display: flex;
  gap: 0;
  padding: 0;
  min-height: 0;
}

.app-nav {
  width: 248px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  overflow-y: auto;
  min-height: 0;
  background: #fff;
  border-right: 1px solid #d8dde3;
}

.app-shell-dark .app-nav {
  background: #16181c;
  border-right-color: #2c3138;
}

.nav-section {
  border-radius: 0;
  background: transparent;
  border: none;
  border-bottom: 1px solid #e6eaee;
  overflow: hidden;
}

.nav-section-active {
  border-color: #e6eaee;
  box-shadow: none;
}

.nav-section-header {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 0.82rem;
  font-weight: 600;
  color: inherit;
  text-align: left;
}

.nav-section-title-btn {
  flex: 1 1;
  min-width: 0;
  padding: 2px 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  text-align: left;
}

.nav-layer-btn {
  flex: 1 1;
  min-width: 0;
  padding: 9px 12px;
  border: none;
  border-left: 2px solid transparent;
  border-radius: 0;
  background: transparent;
  cursor: pointer;
  font-size: inherit;
  font-weight: 500;
  color: #3d4450;
  text-align: left;
  transition: color 0.12s ease, background 0.12s ease, border-color 0.12s ease;
}

.nav-layer-btn:hover {
  background: #f4f6f8;
  border-color: transparent;
  color: #111827;
}

.nav-layer-btn-on {
  background: transparent;
  border-left-color: #1f4e79;
  color: #111827;
  font-weight: 600;
}

.nav-section-active .nav-section-header {
  background: transparent;
  color: inherit;
}

.nav-section-title {
  flex: 1 1;
  min-width: 0;
  padding: 9px 12px;
  font-weight: 600;
}

.nav-section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.nav-chevron-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-height: 100%;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  cursor: pointer;
  color: inherit;
}

.nav-chevron-btn:hover {
  background: rgba(15, 23, 42, 0.06);
}

.nav-chevron {
  display: inline-block;
  transition: transform 0.2s ease;
  font-size: 0.85rem;
  opacity: 0.7;
}

.nav-chevron-open {
  transform: rotate(90deg);
}

.nav-section-content {
  border-top: 1px solid #eef1f4;
}

.nav-section-body {
  padding: 8px 12px 12px;
  max-height: min(70vh, 720px);
  overflow-y: auto;
}

.nav-block {
  margin-bottom: 14px;
}

.nav-block-title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 8px;
}

.nav-check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 0.85rem;
  cursor: pointer;
}

.nav-check-small {
  flex-wrap: wrap;
  font-size: 0.8rem;
}

.nav-check-small input[type="range"] {
  width: 100%;
  margin-top: 4px;
}

.nav-check-disabled {
  opacity: 0.55;
}

.nav-nested {
  margin-left: 1.25rem;
  margin-top: 4px;
}

.nav-input {
  width: 100%;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid #c5ccd4;
  padding: 5px 8px;
  font-size: 0.82rem;
  margin-bottom: 6px;
}

.nav-input-small {
  width: 4.5rem;
  margin-left: 4px;
  margin-bottom: 0;
}

.nav-btn {
  border: 1px solid #c5ccd4;
  border-radius: 2px;
  padding: 5px 10px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  background: #fff;
  color: #1e293b;
}

.nav-btn-small {
  padding: 4px 8px;
  font-size: 0.75rem;
  margin-right: 4px;
  margin-bottom: 4px;
}

.nav-btn-primary {
  background: #2980b9;
  color: #fff;
  width: 100%;
}

.nav-btn-accent {
  background: #1890ff;
  color: #fff;
  width: 100%;
  margin-top: 4px;
}

.nav-error {
  color: #dc2626;
  font-size: 0.8rem;
  margin-top: 4px;
}

.nav-success {
  color: #16a34a;
  font-size: 0.8rem;
  margin-top: 4px;
}

.nav-muted {
  font-size: 0.8rem;
  color: #64748b;
}

.nav-result-info {
  font-size: 0.78rem;
  color: #475569;
  margin-top: 6px;
  line-height: 1.35;
}

.nav-year-row {
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 0.8rem;
}

.nav-preset-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.severity-swatch {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.hourly-series-controls {
  flex-shrink: 0;
  margin-bottom: 10px;
}

.hourly-series-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
}

.hourly-direction-toggle {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 8px;
  flex-shrink: 0;
}

.hourly-direction-toggle-title {
  font-size: 0.8rem;
  font-weight: 600;
}

.hourly-direction-toggle-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
}

.hourly-direction-option {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.hourly-direction-stroke-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
  margin: 0 0 8px;
  flex-shrink: 0;
  font-size: 0.72rem;
  color: inherit;
}

.hourly-direction-stroke-legend-title {
  font-weight: 600;
}

.hourly-direction-stroke-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.hourly-series-toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  max-height: 72px;
  overflow-y: auto;
  padding-right: 4px;
}

.hourly-series-toggle {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.hourly-series-swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

.gazettal-direction-legend {
  position: absolute;
  left: 12px;
  bottom: 12px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #d8dde3;
  border-radius: 2px;
  padding: 7px 9px;
  font-size: 0.72rem;
  line-height: 1.35;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
  pointer-events: none;
  max-width: min(240px, calc(100% - 24px));
}

.gazettal-direction-legend-dark {
  background: rgba(35, 39, 47, 0.94);
  border-color: #3a3f4b;
  color: #f1f5f9;
}

.gazettal-direction-legend-title {
  font-weight: 700;
  margin-bottom: 4px;
}

.gazettal-direction-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.gazettal-direction-legend-arrow {
  display: inline-block;
  font-size: 14px;
  line-height: 1;
  width: 14px;
  text-align: center;
  flex-shrink: 0;
}

.gazettal-arrow-head {
  background: transparent;
  border: none;
}

.nav-disclaimer {
  font-size: 0.72rem;
  color: #64748b;
  line-height: 1.4;
  padding: 6px 0 0;
  background: transparent;
  border: none;
  border-radius: 0;
  border-top: 1px solid #e6eaee;
}

.nav-recommend {
  margin-top: 8px;
}

.nav-modal-pre {
  white-space: pre-wrap;
  word-break: break-word;
  background: #f8fafc;
  padding: 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  max-height: 50vh;
  overflow: auto;
}

.main-panel {
  flex: 1 1;
  display: flex;
  gap: 0;
  min-width: 0;
  min-height: 0;
}

.map-area {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  position: relative;
}

.map-view-root {
  position: relative;
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.map-view-root.is-loading .leaflet-container {
  filter: blur(8px);
  pointer-events: none;
}

.map-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  background: rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.map-loading-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  min-width: 160px;
  background: rgba(15, 23, 42, 0.9);
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
}

.map-loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: #fff;
  border-radius: 50%;
  animation: map-spin 0.75s linear infinite;
}

.map-loading-label {
  font-size: 0.92rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-align: center;
}

@keyframes map-spin {
  to {
    transform: rotate(360deg);
  }
}

.site-panel {
  width: min(440px, 36vw);
  flex-shrink: 0;
  min-height: 0;
  display: flex;
}

/* Landscape A4 at ~half of 1080p (960px). 297:210 is ISO A4.
   Height can grow below the A4 body so hover readouts do not shrink the chart. */
.chart-overlay-panel {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1100;
  width: min(960px, 50vw);
  max-width: calc(100% - 24px);
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: auto;
  overflow: visible;
}

.leaflet-container {
  border-radius: 0 !important;
}

.chart-overlay-panel > * {
  flex: 0 0 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}

.chart-overlay-panel.is-empty {
  width: 80px;
  height: 240px;
}

.chart-overlay-panel.is-empty > * {
  height: 100%;
}

.chart-overlay-body {
  width: 100%;
  aspect-ratio: 297 / 210;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.chart-hover-extend {
  flex: 0 0 auto;
  padding: 10px 16px 12px;
  border-top: 1px solid #e2e8f0;
}

.app-shell-dark .chart-hover-extend {
  border-top-color: #3a3f4b;
}

.chart-empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 8px !important;
  height: 100% !important;
  min-height: 0 !important;
}

.chart-empty-label {
  margin: 0;
  font-weight: 600;
  font-size: 0.78rem;
  line-height: 1.35;
  text-align: center;
}

.chart-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  flex-shrink: 0;
}

.chart-panel-header-text {
  min-width: 0;
  flex: 1 1;
}

.chart-export-btn {
  flex-shrink: 0;
  margin: 0;
  padding: 4px 8px;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.2;
  border-radius: 2px;
  border: 1px solid #c5ccd4;
  cursor: pointer;
  white-space: nowrap;
}

.chart-export-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chart-export-cluster {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  flex-shrink: 0;
}

.chart-export-both {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.68rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  opacity: 0.85;
}

.map-loading-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.85);
  color: #fff;
  padding: 4px 8px;
  border-radius: 2px;
  font-size: 0.75rem;
  pointer-events: none;
}

.map-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 320px;
  padding: 24px;
  text-align: center;
  color: #64748b;
  font-size: 0.95rem;
  border-radius: 0;
  background: rgba(241, 245, 249, 0.6);
}

.app-shell-dark .map-placeholder {
  color: #94a3b8;
  background: rgba(35, 39, 47, 0.6);
}

.app-shell-dark .nav-section {
  background: transparent;
  border-color: #2c3138;
}

.app-shell-dark .nav-section-header {
  background: transparent;
  color: #f1f5f9;
}

.app-shell-dark .nav-section-active .nav-section-header {
  background: transparent;
  color: #f1f5f9;
}

.app-shell-dark .nav-layer-btn {
  background: transparent;
  border-color: transparent;
  color: #d5dbe3;
}

.app-shell-dark .nav-layer-btn:hover {
  background: #1f2329;
  border-color: transparent;
  color: #f8fafc;
}

.app-shell-dark .nav-layer-btn-on {
  background: transparent;
  border-left-color: #6ea8d4;
  color: #f8fafc;
}

.app-shell-dark .nav-chevron-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

.app-shell-dark .nav-section-content {
  border-top-color: #3a3f4b;
}

.app-shell-dark .nav-input {
  background: #1a1d23;
  border-color: #475569;
  color: #f1f5f9;
}

.app-shell-dark .nav-btn {
  background: #1c1f24;
  border-color: #3a4048;
  color: #e8edf2;
}

.app-shell-dark .nav-btn-primary,
.app-shell-dark .nav-btn-accent {
  color: #fff;
  border-color: transparent;
}

.app-shell-dark .nav-disclaimer {
  background: transparent;
  border-top-color: #2c3138;
  color: #94a3b8;
}

.planning-input-wide {
  width: 6.5rem !important;
}

.planning-search-results {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 8px 0 10px;
  max-height: 180px;
  overflow-y: auto;
}

.planning-search-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  text-align: left;
  border: 1px solid #e2e8f0;
  border-radius: 2px;
  background: #fff;
  padding: 6px 8px;
  cursor: pointer;
  font-size: 0.78rem;
}

.planning-search-item strong {
  font-size: 0.82rem;
}

.planning-search-item span {
  color: #64748b;
}

.planning-search-item:hover {
  border-color: #2980b9;
  background: #f8fafc;
}

.app-shell-dark .planning-search-item {
  background: #1a1d23;
  border-color: #475569;
  color: #f1f5f9;
}

.app-shell-dark .planning-search-item span {
  color: #94a3b8;
}

.planning-road-desc {
  margin-top: 6px;
  font-size: 0.78rem;
}

.planning-zoom-btn {
  margin-top: 8px;
}

.planning-work-areas {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.planning-work-area-row {
  border: 1px solid #e2e8f0;
  border-radius: 2px;
  padding: 8px;
  background: #f8fafc;
}

.app-shell-dark .planning-work-area-row {
  background: #1a1d23;
  border-color: #475569;
}

.planning-work-area-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  font-size: 0.82rem;
}

.planning-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 0.75rem;
  margin-bottom: 6px;
  color: #64748b;
}

.app-shell-dark .planning-field {
  color: #94a3b8;
}

.planning-detail-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.planning-detail-card {
  border: 1px solid #e2e8f0;
  border-radius: 2px;
  padding: 8px 10px;
  font-size: 0.85rem;
}

.app-shell-dark .planning-detail-card {
  border-color: #3a3f4b;
}

.planning-detail-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 6px;
  font-size: 0.82rem;
}

.planning-detail-table th {
  text-align: left;
  padding: 3px 8px 3px 0;
  color: #64748b;
  font-weight: 600;
  white-space: nowrap;
}

.app-shell-dark .planning-detail-table th {
  color: #94a3b8;
}

.planning-detail-table td {
  padding: 3px 0;
}

.planning-detail-error {
  color: #dc2626;
  font-size: 0.8rem;
  margin-top: 4px;
}

.planning-detail-ok {
  color: #16a34a;
  font-size: 0.85rem;
  margin: 0;
}

.planning-detail-muted {
  color: #64748b;
  font-size: 0.85rem;
  margin: 0;
}

.planning-detail-issues {
  margin: 0;
  padding-left: 1.1rem;
  font-size: 0.85rem;
}

.planning-detail-warning {
  color: #dc2626;
  margin-bottom: 4px;
}

.planning-detail-ok-item {
  color: #15803d;
  margin-bottom: 4px;
}

.app-shell-dark .planning-detail-ok-item {
  color: #4ade80;
}

.planning-legend-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  margin-bottom: 4px;
}

.planning-legend-line {
  display: inline-block;
  width: 28px;
  height: 0;
  border-top-width: 4px;
  border-top-style: solid;
  flex-shrink: 0;
}

.planning-legend-road {
  border-top-color: #64748b;
}

.planning-legend-signage {
  border-top-color: #2563eb;
  border-top-style: dashed;
}

.planning-legend-work {
  border-top-color: #dc2626;
}

.planning-legend-overlap {
  border-top-color: #a855f7;
}

.planning-pick-badge {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #f59e0b;
  border-radius: 2px;
  padding: 8px 14px;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}

.app-shell-dark .planning-pick-badge {
  background: #422006;
  color: #fcd34d;
  border-color: #b45309;
}

.planning-pick-badge-warn {
  background: #fee2e2;
  color: #991b1b;
  border-color: #f87171;
}

.app-shell-dark .planning-pick-badge-warn {
  background: #450a0a;
  color: #fca5a5;
  border-color: #ef4444;
}

.planning-pick-hint {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  background: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 2px;
  padding: 6px 8px;
  font-size: 0.78rem;
  margin-bottom: 8px;
  color: #92400e;
}

.app-shell-dark .planning-pick-hint {
  background: #422006;
  border-color: #b45309;
  color: #fcd34d;
}

.planning-field-row {
  display: flex;
  gap: 6px;
  align-items: center;
}

.planning-field-row .nav-input {
  flex: 1 1;
  min-width: 0;
}

.planning-pick-btn {
  flex-shrink: 0;
  white-space: nowrap;
}

.planning-pick-btn-active {
  background: #f59e0b !important;
  color: #fff !important;
}

.planning-work-area-row-active {
  border-color: #f59e0b !important;
  box-shadow: 0 0 0 1px #f59e0b;
}

.planning-work-area-tooltip {
  font-weight: 600;
  font-size: 0.82rem;
  padding: 4px 8px;
  border-radius: 2px;
  white-space: nowrap;
}

.planning-file-input {
  display: none;
}

.planning-io-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.planning-io-buttons .nav-btn {
  flex: 1 1;
  width: auto;
}

.planning-import-message {
  font-size: 0.78rem;
  margin-bottom: 6px;
  padding: 6px 8px;
  border-radius: 2px;
}

.planning-import-ok {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #6ee7b7;
}

.planning-import-error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.app-shell-dark .planning-import-ok {
  background: #052e16;
  color: #6ee7b7;
  border-color: #047857;
}

.app-shell-dark .planning-import-error {
  background: #450a0a;
  color: #fca5a5;
  border-color: #b91c1c;
}

@media (max-width: 1100px) {
  .workspace {
    flex-direction: column;
  }

  .app-nav {
    width: 100%;
    padding-right: 0;
    max-height: 40vh;
    border-right: none;
    border-bottom: 1px solid #d8dde3;
  }

  .app-shell-dark .app-nav {
    border-bottom-color: #2c3138;
  }

  .main-panel {
    flex-direction: column;
  }

  .site-panel {
    width: 100%;
    max-height: 42vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,MAAM;EACN,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,MAAM;EACN,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;EAC5C,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,MAAM;EACN,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,aAAa;AACf;;AAEA;iFACiF;AACjF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".app-shell {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n\n.app-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 10px 20px;\n  padding: 0.5rem 1rem 0.45rem;\n  flex-shrink: 0;\n  border-bottom: 1px solid #d8dde3;\n  background: #fff;\n}\n\n.app-shell-dark .app-header {\n  background: #16181c;\n  border-bottom-color: #2c3138;\n}\n\n.app-header h1 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  flex: 1 1 auto;\n  min-width: 12rem;\n}\n\n.nsw-region-link {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 0;\n  border-radius: 0;\n  background: transparent;\n  color: #1f4e79;\n  text-decoration: none;\n  font-size: 0.8rem;\n  font-weight: 600;\n  flex-shrink: 0;\n  letter-spacing: 0.01em;\n}\n\n.nsw-region-link:hover {\n  background: transparent;\n  color: #163a5a;\n  text-decoration: underline;\n}\n\n.app-shell-dark .nsw-region-link {\n  background: transparent;\n  color: #8ec5e8;\n}\n\n.app-shell-dark .nsw-region-link:hover {\n  background: transparent;\n  color: #c5e1f5;\n}\n\n.map-search-bar {\n  flex: 1 1 280px;\n  max-width: 520px;\n  margin: 0;\n}\n\n.map-search-label {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.map-search-controls {\n  display: flex;\n  gap: 6px;\n  align-items: stretch;\n}\n\n.map-search-input {\n  flex: 1;\n  min-width: 0;\n  box-sizing: border-box;\n  border-radius: 2px;\n  border: 1px solid #c5ccd4;\n  padding: 6px 9px;\n  font-size: 0.85rem;\n}\n\n.map-search-btn {\n  border: 1px solid #c5ccd4;\n  border-radius: 2px;\n  padding: 6px 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  background: #fff;\n  color: #1e293b;\n  flex-shrink: 0;\n}\n\n.map-search-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.map-search-btn-primary {\n  background: #2980b9;\n  color: #fff;\n}\n\n.map-search-btn-icon {\n  padding: 7px 10px;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.map-search-error {\n  color: #dc2626;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n.app-shell-dark .map-search-label {\n  color: #94a3b8;\n}\n\n.app-shell-dark .map-search-input {\n  background: #1a1d23;\n  border-color: #475569;\n  color: #f1f5f9;\n}\n\n.app-shell-dark .map-search-btn {\n  background: #3a3f4b;\n  color: #f1f5f9;\n}\n\n.app-shell-dark .map-search-btn-primary {\n  background: #2980b9;\n  color: #fff;\n}\n\n.workspace {\n  flex: 1;\n  display: flex;\n  gap: 0;\n  padding: 0;\n  min-height: 0;\n}\n\n.app-nav {\n  width: 248px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  overflow-y: auto;\n  min-height: 0;\n  background: #fff;\n  border-right: 1px solid #d8dde3;\n}\n\n.app-shell-dark .app-nav {\n  background: #16181c;\n  border-right-color: #2c3138;\n}\n\n.nav-section {\n  border-radius: 0;\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid #e6eaee;\n  overflow: hidden;\n}\n\n.nav-section-active {\n  border-color: #e6eaee;\n  box-shadow: none;\n}\n\n.nav-section-header {\n  width: 100%;\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: inherit;\n  text-align: left;\n}\n\n.nav-section-title-btn {\n  flex: 1;\n  min-width: 0;\n  padding: 2px 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: inherit;\n  font-weight: inherit;\n  color: inherit;\n  text-align: left;\n}\n\n.nav-layer-btn {\n  flex: 1;\n  min-width: 0;\n  padding: 9px 12px;\n  border: none;\n  border-left: 2px solid transparent;\n  border-radius: 0;\n  background: transparent;\n  cursor: pointer;\n  font-size: inherit;\n  font-weight: 500;\n  color: #3d4450;\n  text-align: left;\n  transition: color 0.12s ease, background 0.12s ease, border-color 0.12s ease;\n}\n\n.nav-layer-btn:hover {\n  background: #f4f6f8;\n  border-color: transparent;\n  color: #111827;\n}\n\n.nav-layer-btn-on {\n  background: transparent;\n  border-left-color: #1f4e79;\n  color: #111827;\n  font-weight: 600;\n}\n\n.nav-section-active .nav-section-header {\n  background: transparent;\n  color: inherit;\n}\n\n.nav-section-title {\n  flex: 1;\n  min-width: 0;\n  padding: 9px 12px;\n  font-weight: 600;\n}\n\n.nav-section-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.nav-chevron-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  min-height: 100%;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  cursor: pointer;\n  color: inherit;\n}\n\n.nav-chevron-btn:hover {\n  background: rgba(15, 23, 42, 0.06);\n}\n\n.nav-chevron {\n  display: inline-block;\n  transition: transform 0.2s ease;\n  font-size: 0.85rem;\n  opacity: 0.7;\n}\n\n.nav-chevron-open {\n  transform: rotate(90deg);\n}\n\n.nav-section-content {\n  border-top: 1px solid #eef1f4;\n}\n\n.nav-section-body {\n  padding: 8px 12px 12px;\n  max-height: min(70vh, 720px);\n  overflow-y: auto;\n}\n\n.nav-block {\n  margin-bottom: 14px;\n}\n\n.nav-block-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.nav-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.nav-check-small {\n  flex-wrap: wrap;\n  font-size: 0.8rem;\n}\n\n.nav-check-small input[type=\"range\"] {\n  width: 100%;\n  margin-top: 4px;\n}\n\n.nav-check-disabled {\n  opacity: 0.55;\n}\n\n.nav-nested {\n  margin-left: 1.25rem;\n  margin-top: 4px;\n}\n\n.nav-input {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 2px;\n  border: 1px solid #c5ccd4;\n  padding: 5px 8px;\n  font-size: 0.82rem;\n  margin-bottom: 6px;\n}\n\n.nav-input-small {\n  width: 4.5rem;\n  margin-left: 4px;\n  margin-bottom: 0;\n}\n\n.nav-btn {\n  border: 1px solid #c5ccd4;\n  border-radius: 2px;\n  padding: 5px 10px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  background: #fff;\n  color: #1e293b;\n}\n\n.nav-btn-small {\n  padding: 4px 8px;\n  font-size: 0.75rem;\n  margin-right: 4px;\n  margin-bottom: 4px;\n}\n\n.nav-btn-primary {\n  background: #2980b9;\n  color: #fff;\n  width: 100%;\n}\n\n.nav-btn-accent {\n  background: #1890ff;\n  color: #fff;\n  width: 100%;\n  margin-top: 4px;\n}\n\n.nav-error {\n  color: #dc2626;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n.nav-success {\n  color: #16a34a;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n.nav-muted {\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.nav-result-info {\n  font-size: 0.78rem;\n  color: #475569;\n  margin-top: 6px;\n  line-height: 1.35;\n}\n\n.nav-year-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 8px;\n  font-size: 0.8rem;\n}\n\n.nav-preset-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.severity-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.hourly-series-controls {\n  flex-shrink: 0;\n  margin-bottom: 10px;\n}\n\n.hourly-series-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.hourly-direction-toggle {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 8px;\n  flex-shrink: 0;\n}\n\n.hourly-direction-toggle-title {\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.hourly-direction-toggle-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n}\n\n.hourly-direction-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.75rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.hourly-direction-stroke-legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 14px;\n  margin: 0 0 8px;\n  flex-shrink: 0;\n  font-size: 0.72rem;\n  color: inherit;\n}\n\n.hourly-direction-stroke-legend-title {\n  font-weight: 600;\n}\n\n.hourly-direction-stroke-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.hourly-series-toggles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 12px;\n  max-height: 72px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.hourly-series-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.75rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.hourly-series-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.gazettal-direction-legend {\n  position: absolute;\n  left: 12px;\n  bottom: 12px;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid #d8dde3;\n  border-radius: 2px;\n  padding: 7px 9px;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);\n  pointer-events: none;\n  max-width: min(240px, calc(100% - 24px));\n}\n\n.gazettal-direction-legend-dark {\n  background: rgba(35, 39, 47, 0.94);\n  border-color: #3a3f4b;\n  color: #f1f5f9;\n}\n\n.gazettal-direction-legend-title {\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.gazettal-direction-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.gazettal-direction-legend-arrow {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 1;\n  width: 14px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.gazettal-arrow-head {\n  background: transparent;\n  border: none;\n}\n\n.nav-disclaimer {\n  font-size: 0.72rem;\n  color: #64748b;\n  line-height: 1.4;\n  padding: 6px 0 0;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  border-top: 1px solid #e6eaee;\n}\n\n.nav-recommend {\n  margin-top: 8px;\n}\n\n.nav-modal-pre {\n  white-space: pre-wrap;\n  word-break: break-word;\n  background: #f8fafc;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  max-height: 50vh;\n  overflow: auto;\n}\n\n.main-panel {\n  flex: 1;\n  display: flex;\n  gap: 0;\n  min-width: 0;\n  min-height: 0;\n}\n\n.map-area {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  position: relative;\n}\n\n.map-view-root {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n}\n\n.map-view-root.is-loading .leaflet-container {\n  filter: blur(8px);\n  pointer-events: none;\n}\n\n.map-loading-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0;\n  background: rgba(15, 23, 42, 0.28);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.map-loading-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 20px;\n  min-width: 160px;\n  background: rgba(15, 23, 42, 0.9);\n  color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);\n}\n\n.map-loading-spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid rgba(255, 255, 255, 0.25);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: map-spin 0.75s linear infinite;\n}\n\n.map-loading-label {\n  font-size: 0.92rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  text-align: center;\n}\n\n@keyframes map-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.site-panel {\n  width: min(440px, 36vw);\n  flex-shrink: 0;\n  min-height: 0;\n  display: flex;\n}\n\n/* Landscape A4 at ~half of 1080p (960px). 297:210 is ISO A4.\n   Height can grow below the A4 body so hover readouts do not shrink the chart. */\n.chart-overlay-panel {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 1100;\n  width: min(960px, 50vw);\n  max-width: calc(100% - 24px);\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: auto;\n  overflow: visible;\n}\n\n.leaflet-container {\n  border-radius: 0 !important;\n}\n\n.chart-overlay-panel > * {\n  flex: 0 0 auto;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n}\n\n.chart-overlay-panel.is-empty {\n  width: 80px;\n  height: 240px;\n}\n\n.chart-overlay-panel.is-empty > * {\n  height: 100%;\n}\n\n.chart-overlay-body {\n  width: 100%;\n  aspect-ratio: 297 / 210;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.chart-hover-extend {\n  flex: 0 0 auto;\n  padding: 10px 16px 12px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.app-shell-dark .chart-hover-extend {\n  border-top-color: #3a3f4b;\n}\n\n.chart-empty-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 14px 8px !important;\n  height: 100% !important;\n  min-height: 0 !important;\n}\n\n.chart-empty-label {\n  margin: 0;\n  font-weight: 600;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.chart-panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.chart-panel-header-text {\n  min-width: 0;\n  flex: 1;\n}\n\n.chart-export-btn {\n  flex-shrink: 0;\n  margin: 0;\n  padding: 4px 8px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  line-height: 1.2;\n  border-radius: 2px;\n  border: 1px solid #c5ccd4;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.chart-export-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.chart-export-cluster {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 5px;\n  flex-shrink: 0;\n}\n\n.chart-export-both {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.68rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  opacity: 0.85;\n}\n\n.map-loading-badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 1000;\n  background: rgba(15, 23, 42, 0.85);\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 2px;\n  font-size: 0.75rem;\n  pointer-events: none;\n}\n\n.map-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 320px;\n  padding: 24px;\n  text-align: center;\n  color: #64748b;\n  font-size: 0.95rem;\n  border-radius: 0;\n  background: rgba(241, 245, 249, 0.6);\n}\n\n.app-shell-dark .map-placeholder {\n  color: #94a3b8;\n  background: rgba(35, 39, 47, 0.6);\n}\n\n.app-shell-dark .nav-section {\n  background: transparent;\n  border-color: #2c3138;\n}\n\n.app-shell-dark .nav-section-header {\n  background: transparent;\n  color: #f1f5f9;\n}\n\n.app-shell-dark .nav-section-active .nav-section-header {\n  background: transparent;\n  color: #f1f5f9;\n}\n\n.app-shell-dark .nav-layer-btn {\n  background: transparent;\n  border-color: transparent;\n  color: #d5dbe3;\n}\n\n.app-shell-dark .nav-layer-btn:hover {\n  background: #1f2329;\n  border-color: transparent;\n  color: #f8fafc;\n}\n\n.app-shell-dark .nav-layer-btn-on {\n  background: transparent;\n  border-left-color: #6ea8d4;\n  color: #f8fafc;\n}\n\n.app-shell-dark .nav-chevron-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.app-shell-dark .nav-section-content {\n  border-top-color: #3a3f4b;\n}\n\n.app-shell-dark .nav-input {\n  background: #1a1d23;\n  border-color: #475569;\n  color: #f1f5f9;\n}\n\n.app-shell-dark .nav-btn {\n  background: #1c1f24;\n  border-color: #3a4048;\n  color: #e8edf2;\n}\n\n.app-shell-dark .nav-btn-primary,\n.app-shell-dark .nav-btn-accent {\n  color: #fff;\n  border-color: transparent;\n}\n\n.app-shell-dark .nav-disclaimer {\n  background: transparent;\n  border-top-color: #2c3138;\n  color: #94a3b8;\n}\n\n.planning-input-wide {\n  width: 6.5rem !important;\n}\n\n.planning-search-results {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 8px 0 10px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.planning-search-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  width: 100%;\n  text-align: left;\n  border: 1px solid #e2e8f0;\n  border-radius: 2px;\n  background: #fff;\n  padding: 6px 8px;\n  cursor: pointer;\n  font-size: 0.78rem;\n}\n\n.planning-search-item strong {\n  font-size: 0.82rem;\n}\n\n.planning-search-item span {\n  color: #64748b;\n}\n\n.planning-search-item:hover {\n  border-color: #2980b9;\n  background: #f8fafc;\n}\n\n.app-shell-dark .planning-search-item {\n  background: #1a1d23;\n  border-color: #475569;\n  color: #f1f5f9;\n}\n\n.app-shell-dark .planning-search-item span {\n  color: #94a3b8;\n}\n\n.planning-road-desc {\n  margin-top: 6px;\n  font-size: 0.78rem;\n}\n\n.planning-zoom-btn {\n  margin-top: 8px;\n}\n\n.planning-work-areas {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.planning-work-area-row {\n  border: 1px solid #e2e8f0;\n  border-radius: 2px;\n  padding: 8px;\n  background: #f8fafc;\n}\n\n.app-shell-dark .planning-work-area-row {\n  background: #1a1d23;\n  border-color: #475569;\n}\n\n.planning-work-area-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n  font-size: 0.82rem;\n}\n\n.planning-field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 0.75rem;\n  margin-bottom: 6px;\n  color: #64748b;\n}\n\n.app-shell-dark .planning-field {\n  color: #94a3b8;\n}\n\n.planning-detail-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.planning-detail-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 2px;\n  padding: 8px 10px;\n  font-size: 0.85rem;\n}\n\n.app-shell-dark .planning-detail-card {\n  border-color: #3a3f4b;\n}\n\n.planning-detail-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 6px;\n  font-size: 0.82rem;\n}\n\n.planning-detail-table th {\n  text-align: left;\n  padding: 3px 8px 3px 0;\n  color: #64748b;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.app-shell-dark .planning-detail-table th {\n  color: #94a3b8;\n}\n\n.planning-detail-table td {\n  padding: 3px 0;\n}\n\n.planning-detail-error {\n  color: #dc2626;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n.planning-detail-ok {\n  color: #16a34a;\n  font-size: 0.85rem;\n  margin: 0;\n}\n\n.planning-detail-muted {\n  color: #64748b;\n  font-size: 0.85rem;\n  margin: 0;\n}\n\n.planning-detail-issues {\n  margin: 0;\n  padding-left: 1.1rem;\n  font-size: 0.85rem;\n}\n\n.planning-detail-warning {\n  color: #dc2626;\n  margin-bottom: 4px;\n}\n\n.planning-detail-ok-item {\n  color: #15803d;\n  margin-bottom: 4px;\n}\n\n.app-shell-dark .planning-detail-ok-item {\n  color: #4ade80;\n}\n\n.planning-legend-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.82rem;\n  margin-bottom: 4px;\n}\n\n.planning-legend-line {\n  display: inline-block;\n  width: 28px;\n  height: 0;\n  border-top-width: 4px;\n  border-top-style: solid;\n  flex-shrink: 0;\n}\n\n.planning-legend-road {\n  border-top-color: #64748b;\n}\n\n.planning-legend-signage {\n  border-top-color: #2563eb;\n  border-top-style: dashed;\n}\n\n.planning-legend-work {\n  border-top-color: #dc2626;\n}\n\n.planning-legend-overlap {\n  border-top-color: #a855f7;\n}\n\n.planning-pick-badge {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #f59e0b;\n  border-radius: 2px;\n  padding: 8px 14px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  pointer-events: none;\n}\n\n.app-shell-dark .planning-pick-badge {\n  background: #422006;\n  color: #fcd34d;\n  border-color: #b45309;\n}\n\n.planning-pick-badge-warn {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #f87171;\n}\n\n.app-shell-dark .planning-pick-badge-warn {\n  background: #450a0a;\n  color: #fca5a5;\n  border-color: #ef4444;\n}\n\n.planning-pick-hint {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  background: #fef3c7;\n  border: 1px solid #fbbf24;\n  border-radius: 2px;\n  padding: 6px 8px;\n  font-size: 0.78rem;\n  margin-bottom: 8px;\n  color: #92400e;\n}\n\n.app-shell-dark .planning-pick-hint {\n  background: #422006;\n  border-color: #b45309;\n  color: #fcd34d;\n}\n\n.planning-field-row {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.planning-field-row .nav-input {\n  flex: 1;\n  min-width: 0;\n}\n\n.planning-pick-btn {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.planning-pick-btn-active {\n  background: #f59e0b !important;\n  color: #fff !important;\n}\n\n.planning-work-area-row-active {\n  border-color: #f59e0b !important;\n  box-shadow: 0 0 0 1px #f59e0b;\n}\n\n.planning-work-area-tooltip {\n  font-weight: 600;\n  font-size: 0.82rem;\n  padding: 4px 8px;\n  border-radius: 2px;\n  white-space: nowrap;\n}\n\n.planning-file-input {\n  display: none;\n}\n\n.planning-io-buttons {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.planning-io-buttons .nav-btn {\n  flex: 1;\n  width: auto;\n}\n\n.planning-import-message {\n  font-size: 0.78rem;\n  margin-bottom: 6px;\n  padding: 6px 8px;\n  border-radius: 2px;\n}\n\n.planning-import-ok {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #6ee7b7;\n}\n\n.planning-import-error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n\n.app-shell-dark .planning-import-ok {\n  background: #052e16;\n  color: #6ee7b7;\n  border-color: #047857;\n}\n\n.app-shell-dark .planning-import-error {\n  background: #450a0a;\n  color: #fca5a5;\n  border-color: #b91c1c;\n}\n\n@media (max-width: 1100px) {\n  .workspace {\n    flex-direction: column;\n  }\n\n  .app-nav {\n    width: 100%;\n    padding-right: 0;\n    max-height: 40vh;\n    border-right: none;\n    border-bottom: 1px solid #d8dde3;\n  }\n\n  .app-shell-dark .app-nav {\n    border-bottom-color: #2c3138;\n  }\n\n  .main-panel {\n    flex-direction: column;\n  }\n\n  .site-panel {\n    width: 100%;\n    max-height: 42vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
